import {Component, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from "@Services/base/daoService";
import {ActionDataTable, ColumnDataTable, DataTableComponent,} from "@Common/widgets/general/data-table";
import {Bel, BelState} from "../../../common/services/bel/bel/bel.model";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {PubSubService} from "@Common/core/services";
import {BelService} from "../../../common/services/bel/bel/bel.service";
import {filterDirCmpColumn} from "../../versements/versements.component";
import {switchMap} from "rxjs/operators";
import {noop, of} from "rxjs";
import {DialogData, DialogValidationComponent} from "@Common/widgets/general/dialog-validation";


@Component({
  selector: 'app-liste-bel',
  templateUrl: './liste-bel.component.html',
  styleUrls: ['./liste-bel.component.scss']
})
export class ListeBelComponent implements OnInit {
  dsBels: MatDataSourceGeneric<Bel> = new MatDataSourceGeneric<Bel>();
  extraParams: Map<string, string> = new Map<string, string>();
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'label', header: 'Libellé',
      display: (row: Bel) => `${row?.label ?? ''}`,
      tooltip: (row) => `${row?.label ?? ''}`,
      headerFilterToolTip: (row) => `Filtrer sur le Libellé`,
      sort: true
    },
    {
      columnDef: 'observations', header: 'Observations',
      display: (row: Bel) => row.observations,
      tooltip: (row) => row.observations,
      sort: false
    },
    {
      columnDef: 'documents', header: 'Nombre de documents',
      display: (row: Bel) => row.documents_obj.length,
      tooltip: (row) => row.documents_obj.length,
      headerFilterToolTip: (row) => `Filtrer sur nombre de documents`,
      sort: true, flex: 10
    },
    {
      columnDef: 'state', header: 'Etat',
      display: (row: Bel) => this.belSvc.getChipButton(row),
      tooltip: (row) => row.type,
      headerFilterToolTip: (row) => `Filtrer sur état`,
      sort: true, flex: 15
    },
    {
      columnDef: 'reference', header: 'Référence',
      display: (row: Bel) => row.reference,
      tooltip: (row) => row.reference,
      sort: true, flex: 10
    },
  ];
  actions: ActionDataTable[] = [
    {
      label: 'edit', tooltip: 'modifier ce bordereau', icon: 'edit',
      click: (row: Bel) => this._editBel(row),
      iconcolor: 'accent',
    },
    {
      label: 'visualize', tooltip: 'Visualiser ce bordereau', icon: 'remove_red_eye',
      click: (row: Bel) => this._goToBel(row),
      iconcolor: 'accent',
    },
    {
      label: 'bordereaux', tooltip: 'Imprimer le bordereau', icon: 'picture_as_pdf',
      click: (row: Bel) => this._printBel(row),
      iconcolor: 'accent',
    },
  ];
  constructor(@Inject(LOCALE_ID) private locale: string,
              public dialog: MatDialog,
              private router: Router,
              private pubSvc: PubSubService,
              private belSvc: BelService,
  ) {
    this.dsBels.daoService = this.belSvc;
  }

  ngOnInit(): void {
  }

  private _goToBel(bordereau: Bel) {
    this.router.navigate(['elimination/visualisation-bordereau/', bordereau.id]);
  }

  private _editBel(bordereau: Bel) {
    this.router.navigate(['elimination/edition-bordereau/', bordereau.id]);
  }

  private _printBel(bordereau: Bel) {
    console.log(bordereau);
  }

  addBordereau() {
    const data = new DialogData();
    data.title = 'Nouveau Bordereau';
    data.message = `Indiquez ici le libellé de votre nouveau bordereau`;

    data.buttonTextTrue = 'Valider';
    data.buttonTextFalse = 'Annuler';

    data.content = true;
    data.contentElement = 'input';
    data.contentType = 'text';
    data.contentMinLength = 5;
    data.contentPlaceHolder = `Saisir le libellé ici'`;
    data.contentFormOutline = true;
    const dialogRef = this.dialog.open(DialogValidationComponent, {
      data: data, width: '550px', disableClose: true,
    });

    dialogRef.afterClosed().pipe(
      switchMap(
        result => {
          if (result) {
            const new_bel: Bel = {label: result.contentData, state: BelState.CONSTITUTION_REVISION};
            return this.belSvc.create(new_bel);
          }
          return of(result);
        }
      )
    ).subscribe((_bel) => _bel?this.router.navigate(['elimination/edition-bordereau/', _bel.id]):noop());
  }
}
